import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PasswordService } from '../services/PasswordService';

@Component({
    selector: 'user-change-password',
    template: require('./HolChangePasswordComponent.html'),
    styles: [require('./HolChangePasswordComponent.sass')],
})

export class HolChangePasswordComponent implements OnInit {
    message: string;
    messageType: string;

    private redirectUrl = "booking/students";
    private formSubmitted: boolean = false;
    private oldPassword: string;
    private newPassword: string;
    private confirmNewPassword: string;

    constructor(
        private passwordService: PasswordService,
        private router: Router
    ) { }

    ngOnInit() {
        this.message = "";
        this.messageType = "";
    }

    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        this.changePassword(this.oldPassword, this.newPassword);
    }

    private changePassword(oldPassword:string, newPassword: string) {
        this.passwordService.setNewPassword(oldPassword, newPassword)
            .subscribe(
                complete => {
                    this.message = "Changed password successfully. You will be redirected to Children List Page in 5 seconds.";
                    this.messageType = "success";
                    // Delay 5s before redirect to children list page
                    setTimeout( () => {
                        this.redirect(this.redirectUrl);
                    }, 5000);
                },
                error => {
                    this.message = "Invalid old password input.";
                    this.messageType = "alert";
                    this.formSubmitted = false;
                }
            )
    }

    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-change-password/HolChangePasswordComponent.ts